import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMonth } from 'common/types';
import { getMonthItem } from 'utils/dateUtils';

export interface IPeriodState {
  default: IMonth;
}

interface SetPeriodActionPayload {
  target?: keyof IPeriodState;
  month: IMonth;
}

const today = getMonthItem(new Date());
const initialState: IPeriodState = {
  default: today
};

const periodSlice = createSlice({
  name: 'period',
  initialState,
  reducers: {
    setPeriod(state, action: PayloadAction<SetPeriodActionPayload>) {
      const target = action.payload.target || 'default';
      state[target] = action.payload.month;
    },
    resetPeriods(state, action: PayloadAction) {
      state = initialState;
    }
  }
});

export const { setPeriod, resetPeriods } = periodSlice.actions;
export default periodSlice.reducer;
